export default __webpack_public_path__ + "static/media/avatare.869daf65.png";